import styles from "./SkipLink.module.scss";

interface SkipLinkProps {
  targetId?: string;
  label?: string;
  testId?: string;
}

export function SkipLink({
  targetId = "main-content",
  label = "Skip to main content",
  testId = "skip-link",
}: SkipLinkProps) {
  return (
    <a href={`#${targetId}`} className={styles.skipLink} data-testid={testId}>
      {label}
    </a>
  );
}
